/**
 * External Link Warning
 * Shows a confirmation dialog when users click on external links
 */
(function() {
  'use strict';

  const currentHost = window.location.hostname;

  // Partner / trusted sites: no leave-site prompt (still a normal navigation)
  const trustedExternalHosts = ['angeltreetool.org', 'www.angeltreetool.org'];

  // Shopify domains to exclude from warning
  const shopifyDomains = [
    'shopify.com',
    'myshopify.com',
    'shopifycdn.com',
    'shopifysvc.com',
    'shopifyapps.com',
    'shopifycloud.com',
    'shopifypayments.com',
    'checkout.shopify.com',
    'cdn.shopify.com',
    'apps.shopify.com'
  ];

  /**
   * Check if hostname is a Shopify domain
   * @param {string} hostname - The hostname to check
   * @returns {boolean} - True if Shopify domain
   */
  function isShopifyDomain(hostname) {
    return shopifyDomains.some(domain => 
      hostname === domain || hostname.endsWith('.' + domain)
    );
  }

  /**
   * Check if a URL is external
   * @param {string} url - The URL to check
   * @returns {boolean} - True if external, false if internal
   */
  function isExternalLink(url) {
    if (!url) return false;
    
    // Skip mailto, tel, javascript, and anchor links
    if (url.startsWith('mailto:') || 
        url.startsWith('tel:') || 
        url.startsWith('javascript:') || 
        url.startsWith('#')) {
      return false;
    }

    try {
      const linkUrl = new URL(url, window.location.origin);
      
      // Skip if same domain
      if (linkUrl.hostname === currentHost || linkUrl.hostname === '') {
        return false;
      }

      if (trustedExternalHosts.includes(linkUrl.hostname)) {
        return false;
      }
      
      // Skip Shopify domains
      if (isShopifyDomain(linkUrl.hostname)) {
        return false;
      }
      
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Handle click on external links
   * @param {Event} event - The click event
   */
  function handleExternalLinkClick(event) {
    const link = event.target.closest('a');
    
    if (!link) return;
    
    const href = link.getAttribute('href');
    
    if (isExternalLink(href)) {
      // Show browser confirmation dialog
      const confirmLeave = window.confirm(
        'You are about to leave this website and visit an external site.\n\nDo you want to continue?'
      );
      
      if (!confirmLeave) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  /**
   * Initialize external link warning
   */
  function init() {
    // Use event delegation on document body for better performance
    document.body.addEventListener('click', handleExternalLinkClick);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
